import React, { useEffect, useRef, useState } from 'react'
import i18n from 'simple-react-i18n'
import Select from '../../../../components/forms/Select'
import { getIntegrationModes } from '../../../../utils/JobUtils'
import PropTypes from 'prop-types'
import Job from '../../../dto/DtoJob'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import Button from '../../../../components/forms/Button'
import CityAction from '../../../../referencial/components/city/actions/CityAction'
import Checkbox from '../../../../components/forms/Checkbox'
import SelectionTableModal from '../../../../components/modal/SelectionTableModal'
import { normalizeString } from '../../../../utils/StringUtil'
import { Alert, Grid } from '@mui/material'
import { SimpleFilterField } from '../../../../components/datatable/SimpleSelectionTable'
import IntegrationModeDialog from '../IntegrationModeDialog'
import RadioButtons from '../../../../components/forms/RadioButtons'
import { CardTable } from '../../../../components/datatable/NewTable'
import { exportFile } from '../../../../utils/ExportDataUtil'
import Input from '../../../../components/forms/Input'
import SimpleDatePicker from '../../../../components/forms/SimpleDatePicker'
import { uniq } from 'lodash'
import { readImportCsvStationsCodes } from 'import/components/utils/ImportUtils'
import { StyledFieldSet, StyledLegend } from 'components/StyledElements'


const PluvioAreaJob = ({
    isEditMode,
    onChangeFilters,
    filters = {},
}) => {
    const [cityPopupOpen, setCityPopupOpen] = useState(false)
    const [tmpCode, setTmpCode] = useState('')
    const dispatch = useDispatch()

    const {
        cities,
    } = useSelector(store => ({
        cities: store.CityReducer.cities,
    }), shallowEqual)

    useEffect(() => {
        if (!cities.length) {
            dispatch(CityAction.fetchCities())
        }
        if (!Object.keys(filters).length) {
            onChangeFilters({
                importMode: 'DATA_ADD_LAST_DATA',
                stationMode: 'BV',
                codes: [],
                histoType: 'SAFRAN',
                comblLastDays: true,
                comblType: 'ARPEGE',
                arome: true,
                arpege: true,
                ecmwf: true,
                ecmwfSeeds: false,

                rain: true,
                etp: true,
                etr: true,
                temperature: true,
                wind: true,
                humidity: true,
                soilHumidity: true,
                radiation: true,
                drain: true,
                runoff: true,
                humiditySpe: true,
                temperatureMin: true,
                temperatureMax: true,
                snow: true,
                ecmwfSeas: false,
                gefs: false,
            })
        }
    }, [])

    const disabled = !isEditMode
    const codesTypes = [
        { code: 'BV', name: i18n.watershed },
        { code: 'CITY', name: i18n.cities },
    ]

    const histoTypes = [
        { code: 'SAFRAN', name: 'SAFRAN' },
        { code: 'ERA5', name: 'ERA5' },
    ]

    const comblTypes = [
        { code: 'AROME', name: 'AROME' },
        { code: 'ARPEGE', name: 'ARPEGE' },
        { code: 'ECMWF', name: 'ECMWF' },
    ]

    const onChangeBssFile = e => {
        const files = e.target?.files
        if (!isEditMode || !files || files.length === 0) return

        readImportCsvStationsCodes(e, { importFile: e.target }, (codes) => {
            onChangeFilters({ codes: uniq([ ...filters.codes, ...codes ]) })
        })
    }

    const fileInputRef = useRef(null)
    const handleClick = () => {
        fileInputRef.current?.click()
    }
    const stationsCodes = (filters.codes ?? []).map(hydroCode => ({ hydroCode }))

    return (
        <div>
            <Grid container rowSpacing={1} spacing={1} >
                <Grid size={4}>
                    <StyledFieldSet>
                        <StyledLegend>{ i18n.datas }</StyledLegend>
                        <Grid container rowSpacing={1} spacing={1} alignItems='center' justifyContent='center'>
                            <Grid size={8} >
                                <Select
                                    options={ getIntegrationModes().filter(m => m.value.includes('LAST') || m.value.includes('HISTO')) }
                                    obligatory
                                    label={ i18n.dataIntegration } value={ filters.importMode }
                                    labelSpan={ <IntegrationModeDialog /> }
                                    onChange={ v => onChangeFilters({ importMode: v }) }
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={4}>
                                <SimpleDatePicker
                                    label={ i18n.startDate }
                                    value={ filters.startDate }
                                    onChange={ v => onChangeFilters({ startDate: v }) }
                                    max={ filters.endDate }
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={4}>
                                <SimpleDatePicker
                                    label={ i18n.endDate }
                                    value={ filters.endDate }
                                    onChange={ v => onChangeFilters({ endDate: v }) }
                                    min={ filters.startDate }
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={8} >
                                <Select
                                    options={ histoTypes }
                                    obligatory
                                    label={ 'Source des données historique' }
                                    value={ filters.histoType }
                                    onChange={ v => onChangeFilters({ histoType: v }) }
                                    disabled={ true }
                                />
                            </Grid>
                            <Grid container size={6}>
                                <Grid size={12}>
                                    <Checkbox
                                        label={i18n.rain}
                                        checked={filters.rain}
                                        onChange={c => onChangeFilters({ rain: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label={i18n.radiation}
                                        checked={filters.radiation}
                                        onChange={c => onChangeFilters({ radiation: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label={i18n.etp}
                                        checked={filters.etp}
                                        onChange={c => onChangeFilters({ etp: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label='ETR'
                                        checked={filters.etr}
                                        onChange={c => onChangeFilters({ etr: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label='Humidité'
                                        checked={filters.humidity}
                                        onChange={c => onChangeFilters({ humidity: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label='Humidité du sol (SWI)'
                                        checked={filters.soilHumidity}
                                        onChange={c => onChangeFilters({ soilHumidity: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label='Humidité spécifique'
                                        checked={filters.humiditySpe}
                                        onChange={c => onChangeFilters({ humiditySpe: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                            </Grid>
                            <Grid container size={6}>
                                <Grid size={12}>
                                    <Checkbox
                                        label={i18n.temperature}
                                        checked={filters.temperature}
                                        onChange={c => onChangeFilters({ temperature: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label={`${i18n.temperature} Min`}
                                        checked={filters.temperatureMin}
                                        onChange={c => onChangeFilters({ temperatureMin: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label={`${i18n.temperature} Max`}
                                        checked={filters.temperatureMax}
                                        onChange={c => onChangeFilters({ temperatureMax: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label='Vent'
                                        checked={filters.wind}
                                        onChange={c => onChangeFilters({ wind: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label='Drainage'
                                        checked={filters.drain}
                                        onChange={c => onChangeFilters({ drain: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label='Ruissellement'
                                        checked={filters.runoff}
                                        onChange={c => onChangeFilters({ runoff: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label={i18n.snow}
                                        checked={filters.snow}
                                        onChange={c => onChangeFilters({ snow: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </StyledFieldSet>
                </Grid>
                <Grid size={4}>
                    <StyledFieldSet>
                        <StyledLegend>{ 'Derniers jours manquants' }</StyledLegend>
                        <Grid container rowSpacing={1} alignItems='center' justifyContent='center'>
                            <Grid size={12}>
                                <Checkbox
                                    label='Combler les derniers jours manquants'
                                    checked={filters.comblLastDays}
                                    onChange={c => onChangeFilters({ comblLastDays: c })}
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={12}>
                                <Select
                                    options={ comblTypes }
                                    obligatory={ true }
                                    label={ 'Source des données pour le comblage' }
                                    value={ filters.comblType }
                                    onChange={ v => onChangeFilters({ comblType: v }) }
                                    disabled={ true }
                                />
                            </Grid>
                        </Grid>
                    </StyledFieldSet>
                    <StyledFieldSet>
                        <StyledLegend>{ i18n.previData }</StyledLegend>
                        <Grid container rowSpacing={1} alignItems='center' justifyContent='center'>
                            <Grid size={12}>
                                <Checkbox
                                    label='Importer les données de prévisions AROME (3 jours)'
                                    checked={filters.arome}
                                    onChange={c => onChangeFilters({ arome: c })}
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={12}>
                                <Checkbox
                                    label='Importer les données de prévisions ARPEGE (5 jours)'
                                    checked={filters.arpege}
                                    onChange={c => onChangeFilters({ arpege: c })}
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={12}>
                                <Checkbox
                                    label='Importer les données de prévisions ECMWF (15 jours)'
                                    checked={filters.ecmwf}
                                    onChange={c => onChangeFilters({ ecmwf: c })}
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={12}>
                                <Alert severity='info' sx={{ fontSize: '1rem', lineHeight: 'inherit' }}>
                                    {i18n.ecmwfSeedsAvailability}
                                </Alert>
                            </Grid>
                            <Grid size={12}>
                                <Checkbox
                                    label='Importer les seeds ECMWF (utilisé pour la modélisation)'
                                    checked={filters.ecmwfSeeds}
                                    onChange={c => onChangeFilters({ ecmwfSeeds: c })}
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={12}>
                                <Checkbox
                                    label='Importer les seeds ECMWF Saisonnières (215J)'
                                    checked={filters.ecmwfSeas}
                                    onChange={c => onChangeFilters({ ecmwfSeas: c })}
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={12}>
                                <Checkbox
                                    label="Importer les prévisions d'ensemble GEFS (31 membres)"
                                    checked={filters.gefs}
                                    onChange={c => onChangeFilters({ gefs: c })}
                                    disabled={ disabled }
                                />
                            </Grid>
                        </Grid>
                    </StyledFieldSet>
                </Grid>
                <Grid size={4}>
                    <RadioButtons
                        elements={codesTypes}
                        selected={filters.stationMode}
                        onChange={v => onChangeFilters({ stationMode: v, codes: [] })}
                        disabled={ disabled }
                        title={i18n.schemeAgencyID}
                    />
                    {
                        filters.stationMode === 'BV' && (
                            <Grid container alignItems='center' justifyContent='center' spacing={1}>
                                <Grid size={8}>
                                    <Input
                                        value={tmpCode}
                                        onChange={setTmpCode}
                                        title='code'
                                        disabled={!isEditMode}
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <Button title={i18n.add} onClick={() => {
                                        if (tmpCode.length) {
                                            onChangeFilters({ codes: [...filters.codes, tmpCode] })
                                            setTmpCode('')
                                        }
                                    }} disabled={!isEditMode}
                                    />
                                </Grid>
                                <>
                                    <Button
                                        title={i18n.importLabel}
                                        onClick={handleClick}
                                        disabled={!isEditMode}
                                    />
                                    <input
                                        ref={fileInputRef}
                                        type='file'
                                        accept='.csv'
                                        style={{ display: 'none' }}
                                        onChange={onChangeBssFile}
                                    />
                                </>
                                <Grid size={12}>
                                    <CardTable
                                        headers={['hydroCode']}
                                        rows={stationsCodes}
                                        title={i18n.credentials}
                                        lineActions={[
                                            { icon: 'delete', onClick: ({ hydroCode }) => onChangeFilters({ codes: filters.codes.filter(s => s !== hydroCode) }), displayed: isEditMode },
                                        ]}
                                        actions={[{
                                            icon: 'download',
                                            onClick: () => exportFile({
                                                data: [{ ...(stationsCodes[0]), headers: ['hydroCode'] }, ...(stationsCodes.slice(1, stationsCodes.length))],
                                                titleFile: i18n.credentials,
                                            }),
                                            tooltip: i18n.download,
                                        }]}
                                        displayHeaders={false}
                                    />
                                </Grid>
                            </Grid>
                        )
                    }
                    {
                        filters.stationMode === 'CITY' && (
                            <StyledFieldSet>
                                <StyledLegend>{ i18n.cities }</StyledLegend>
                                <Button
                                    title={ `${(filters.codes || []).length} ${i18n.cities}` }
                                    onClick={ () => setCityPopupOpen(true) }
                                    disabled={ disabled }
                                />
                            </StyledFieldSet>
                        )
                    }
                </Grid>
            </Grid>
            <SelectionTableModal
                isOpen={cityPopupOpen}
                onClose={() => setCityPopupOpen(false)}
                onValidate={list => {
                    onChangeFilters({ codes: list })
                    setCityPopupOpen(false)
                }}
                title={i18n.cities}

                listData={cities}
                defaultSelectionList={filters.codes ?? []}

                listHeaders={['code', 'name']}
                listTitle={i18n.cities}
                selectionListTitle={i18n.selectedElements}
                maxHeightTable={'48vh'}


                filterField={SimpleFilterField}
                filterFunction={(list, { searchValue }) => {
                    const searchValueFormat = normalizeString(searchValue)
                    return searchValue ? list.filter(p => normalizeString([p.code, p.name].join('   ')).includes(searchValueFormat)) : list
                }}
            />
        </div>
    )
}

PluvioAreaJob.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    onChangeFilters: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    filters: PropTypes.shape({}),
}

export default PluvioAreaJob